import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Intervencion/addIntervencionAgenda`, method: 'POST', body: values, token: token})
}
